var SECOMAPP = SECOMAPP || {};
SECOMAPP.ca = SECOMAPP.ca || {};

!function(e){var n=!1;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var o=window.Cookies,t=window.Cookies=e();t.noConflict=function(){return window.Cookies=o,t}}}(function(){function e(){for(var e=0,n={};e<arguments.length;e++){var o=arguments[e];for(var t in o)n[t]=o[t]}return n}function n(o){function t(n,r,i){var c;if("undefined"!=typeof document){if(arguments.length>1){if(i=e({path:"/"},t.defaults,i),"number"==typeof i.expires){var a=new Date;a.setMilliseconds(a.getMilliseconds()+864e5*i.expires),i.expires=a}try{c=JSON.stringify(r),/^[\{\[]/.test(c)&&(r=c)}catch(e){}return r=o.write?o.write(r,n):encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=encodeURIComponent(String(n)),n=n.replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent),n=n.replace(/[\(\)]/g,escape),document.cookie=[n,"=",r,i.expires?"; expires="+i.expires.toUTCString():"",i.path?"; path="+i.path:"",i.domain?"; domain="+i.domain:"",i.secure?"; secure":""].join("")}n||(c={});for(var p=document.cookie?document.cookie.split("; "):[],s=/(%[0-9A-Z]{2})+/g,d=0;d<p.length;d++){var f=p[d].split("="),u=f.slice(1).join("=");'"'===u.charAt(0)&&(u=u.slice(1,-1));try{var l=f[0].replace(s,decodeURIComponent);if(u=o.read?o.read(u,l):o(u,l)||u.replace(s,decodeURIComponent),this.json)try{u=JSON.parse(u)}catch(e){}if(n===l){c=u;break}n||(c[l]=u)}catch(e){}}return c}}return t.set=t,t.get=function(e){return t.call(t,e)},t.getJSON=function(){return t.apply({json:!0},[].slice.call(arguments))},t.defaults={},t.remove=function(n,o){t(n,"",e(o,{expires:-1}))},t.withConverter=n,t}return n(function(){})});SECOMAPP.ca.Cookies = Cookies.noConflict();

SECOMAPP.ca.Cookie = SECOMAPP.ca.Cookie || {
    name: 'scm_customer_attribute_app',
    count: 'scm_customer_attribute_count',
    setInstalled: function() {
        SECOMAPP.ca.Cookies.set(this.count, 0);
        SECOMAPP.ca.Cookies.set(this.name, "installed");
    },
    isInstalled: function() {
        var count = SECOMAPP.ca.Cookies.get(this.count);
        if (! count) count = 0;
        count++;
        SECOMAPP.ca.Cookies.set(this.count, count);

        return SECOMAPP.ca.Cookies.get(this.name) === "installed" && count < 3;
    }
};

SECOMAPP.ca.performanceNow = SECOMAPP.ca.performanceNow || function() {
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        return Math.round(performance.now()) + ' ms ';
    } else {
        return '';
    }
};

    if (! SECOMAPP.ca.Cookie.isInstalled()) {
        SECOMAPP.ca.installed = false;
        console.log(SECOMAPP.ca.performanceNow() + 'preload skip');
    } else {
        SECOMAPP.ca.installed = true;
    }

SECOMAPP.ca.jqVersion = SECOMAPP.ca.jqVersion || function(jQuery) {
    return jQuery.fn.jquery.replace(/\.(\d)/g,".0$1").replace(/\.0(\d{2})/g,".$1");
};

if (SECOMAPP.ca.loadingApp !== true && SECOMAPP.ca.installed === true) {
    SECOMAPP.ca.loadingApp = true;

    SECOMAPP.ca.loadScript = SECOMAPP.ca.loadScript || function(url, callback){
        var script = document.createElement("script");
        script.type = "text/javascript";
        if (script.readyState){  // IE
            script.onreadystatechange = function(){
                if (script.readyState == "loaded" || script.readyState == "complete"){
                    script.onreadystatechange = null;
                    callback();
                }
            };
        } else {  // Others
            script.onreadystatechange = callback;
            script.onload = callback;
        }

        script.src = url;
        var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(script, x);
    };

    SECOMAPP.ca.loadStyle = SECOMAPP.ca.loadStyle || function(url){
        var head = document.getElementsByTagName("head")[0];
        var extension = '.css';
        var link = document.createElement("link");
        link.href = url;
        link.type = "text/css";
        link.rel = "stylesheet";
        head.appendChild(link);
    };

    SECOMAPP.ca.startCustomerAttribute = SECOMAPP.ca.startCustomerAttribute || function(jQuery) {
        console.log(SECOMAPP.ca.performanceNow() + 'customer attribute app starting...');

        SECOMAPP.updateMultiSelect = function(name) {
    var checkedCheckboxs = jQuery('.ca-multiselect :checkbox[name="'+name+'"]:checked');
    var val = "";
    checkedCheckboxs.each(function(index, checkbox) {
        if (index > 0) val += "|";
        val += jQuery(checkbox).data('value');
    });
    checkedCheckboxs.val(val);
};

if (SECOMAPP.page == 'cart' ) {
    var cartSubmitFunction = function(event) {
        var formIsValid = true;
        var message = "Please fill this out and you will be able to check out.";
        jQuery('[name^="attributes"], [name="note"]').filter('.required, [required="required"], [required]').each(function() {
            jQuery(this).removeClass('input--error');
            var isEmpty = false;
            if (jQuery(this).hasClass('ca-option')) {
                var name = jQuery(this).attr('name');
                isEmpty = jQuery('[name="'+name+'"]:checked').length == 0;
            } else {
                isEmpty = jQuery(this).val() == '';
            }
            if (isEmpty) {
                formIsValid = false;
                jQuery(this).addClass('input--error');
                var id = jQuery(this).attr('id');
                jQuery('label[for="'+id+'"]').addClass('error');
            }
        });
        if (formIsValid){
            jQuery(this).submit();
        } else {
            if(jQuery('.ca-errors').size() > 0) {
                jQuery('.ca-errors').show();
            } else {
                alert(message);
            }
            event.stopImmediatePropagation();
            return false;
        }
    };

    if (SECOMAPP.ca.jqVersion(jQuery) >= '1.07.00') {
        jQuery('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', cartSubmitFunction);
    } else {
        jQuery('body [name="checkout"], body [name="goto_pp"], body [name="goto_gc"]').bind('click', cartSubmitFunction);
    }

    jQuery('[name^="attributes"], [name="note"]').filter('.required, [required="required"], [required]').focus(function() {
        var id = jQuery(this).attr('id');
        jQuery('label[for="'+id+'"]').removeClass('error');
        jQuery(this).removeClass('input--error');
    });

}
if (SECOMAPP.page == 'cart' || SECOMAPP.page == 'register' || SECOMAPP.page == 'account') {
    jQuery('.ca-multiselect:has(":checkbox[required]")').each(function(index, select){
        var requiredCheckboxes = jQuery(':checkbox[required]', select);
        if(requiredCheckboxes.is(':checked')) {
            requiredCheckboxes.removeAttr('required');
        } else {
            requiredCheckboxes.attr('required', 'required');
        }
        requiredCheckboxes.change(function(){
            if(requiredCheckboxes.is(':checked')) {
                requiredCheckboxes.removeAttr('required');
            } else {
                requiredCheckboxes.attr('required', 'required');
            }
        });
    });
}

if (SECOMAPP.page == 'cart' || SECOMAPP.page == 'register' || SECOMAPP.page == 'account') {
            // load jQueryUI for datepicker
        if (typeof jQuery.ui === 'undefined' || typeof jQuery.ui.datepicker === 'undefined') {
            var cdnStyle = '//code.jquery.com/ui/1.11.4/themes/smoothness/jquery-ui.min.css';
            var cdnScript = '//code.jquery.com/ui/1.11.4/jquery-ui.min.js';
            if (typeof jQuery !== 'undefined') {
                if (SECOMAPP.ca.jqVersion(jQuery) < "1.06.00") {
                    var cdnStyle = '//code.jquery.com/ui/1.8.24/themes/smoothness/jquery-ui.css';
                    var cdnScript = '//code.jquery.com/ui/1.8.24/jquery-ui.min.js';
                }
            } else if (typeof $ !== 'undefined') {
                if (SECOMAPP.ca.jqVersion($) < "1.06.00") {
                    var cdnStyle = '//code.jquery.com/ui/1.8.24/themes/smoothness/jquery-ui.css';
                    var cdnScript = '//code.jquery.com/ui/1.8.24/jquery-ui.min.js';
                }
            }

            SECOMAPP.ca.loadStyle(cdnStyle);
            SECOMAPP.ca.loadScript(cdnScript, function() {
                if(typeof $ !== 'undefined' && typeof $.ui !== 'undefined') {
                    $(".ca-value.datepicker").datepicker();
                } else if(typeof jQuery !== 'undefined' && typeof jQuery.ui !== 'undefined') {
                    jQuery(".ca-value.datepicker").datepicker();
                } else if(typeof window.jQuery !== 'undefined' && typeof window.jQuery.ui !== 'undefined') {
                    window.jQuery(".ca-value.datepicker").datepicker();
                } else {
                    jQuery = $.noConflict();
                    jQuery(".ca-value.datepicker").datepicker();
                }
            });
        } else {
            jQuery(".ca-input.datepicker").datepicker();
        }
    
        }
            jQuery('.ca-cart:not(.ca-errors), .ca-register, .ca-account').show();
        console.log(SECOMAPP.ca.performanceNow() + 'customer attribute app loaded');
        }; // end of SECOMAPP.ca.startCustomerAttributes

    console.log(SECOMAPP.ca.performanceNow() + 'customer attribute script loaded');

    if (SECOMAPP.ca.loadedJs === true) {
        SECOMAPP.ca.startCustomerAttribute(SECOMAPP.jQuery);
    } else {
        if ((typeof $ !== 'undefined') && SECOMAPP.ca.jqVersion($) >= "1.02.06" ) {
            $(document).ready(function() {
                SECOMAPP.jQuery = $;
                try {
                    SECOMAPP.ca.startCustomerAttribute($);
                } catch (err) {
                    console.log(err);
                    console.log(SECOMAPP.ca.performanceNow() + 'customer attribute failed to start, please contact us support@secomapp.com');
                }
            });
        } else if ((typeof jQuery !== 'undefined') && SECOMAPP.ca.jqVersion(jQuery) >= "1.02.06" ) {
            jQuery(document).ready(function() {
                SECOMAPP.jQuery = jQuery;
                try {
                    SECOMAPP.ca.startCustomerAttribute(jQuery);
                } catch (err) {
                    console.log(err);
                    console.log(SECOMAPP.ca.performanceNow() + 'customer attribute failed to start, please contact us support@secomapp.com');
                }
            });
        } else {
            SECOMAPP.ca.loadScript('//code.jquery.com/jquery-1.11.1.min.js', function() {
                SECOMAPP.jQuery = jQuery.noConflict();
                SECOMAPP.jQuery(document).ready(function() {
                    try {
                        SECOMAPP.ca.startCustomerAttribute(SECOMAPP.jQuery);
                    } catch (err) {
                        console.log(err);
                        console.log(SECOMAPP.ca.performanceNow() + 'customer attribute failed to start, please contact us support@secomapp.com');
                    }
                });
            });
        }
    }

} else {
    console.log(SECOMAPP.ca.performanceNow() + 'skip');
}